import {
  Card,
  Checkbox,
  CrudMode,
  DataDisplay,
  formatBoolean,
  Grid,
  pn,
  Stack,
  Typography,
  useElementBreakpoints,
  ValidationErrors,
} from "@compass/core";
import { Input } from "components";
import { LkRole, User, UserEditResource, UserViewResource } from "generated/openApi";
import produce from "immer";
import "moment-timezone";
import PhoneAndroidOutlinedIcon from '@mui/icons-material/PhoneAndroidOutlined';

export const Texting = (props: {
  crudMode: CrudMode;
  user: User;
  userMembership: string;
  reroute?: (userMembership: string, crudMode: CrudMode) => void;
  setUser: (value: User) => void;
  viewResource: UserViewResource;
  editResource: UserEditResource;
  validationErrors: ValidationErrors;
  selectedRole: LkRole | undefined;
}) => {
  const { breakpointsRef, smallFieldBreakpoints } = useElementBreakpoints();
  const properties = props.viewResource.properties || [];

  const canConfigureAndUseTextingField = () => {
    var propertyName = pn<User>("canConfigureAndUseTexting");
    var property = properties.find((x) => x.propertyName === propertyName);

    return props.crudMode === "view" ? (
      <DataDisplay label={property?.displayName}>{formatBoolean(props.user.canConfigureAndUseTexting)}</DataDisplay>
    ) : (
      <Checkbox
        label={property?.displayName}
        checked={props.user.canConfigureAndUseTexting}
        onChange={(e) =>
          props.setUser(
            produce(props.user, (draft) => {
              draft.canConfigureAndUseTexting = e.target.checked;
            })
          )
        }
      />
    );
  };

  const contactField = () => {
    var propertyName = pn<User>("contact");
    var property = properties.find((x) => x.propertyName === propertyName);

    return props.crudMode === "view" ? (
      <DataDisplay label={property?.displayName}>{props.user.contact}</DataDisplay>
    ) : (
      <Input
        modelProperty={property}
        errors={props.validationErrors[propertyName]}
        value={props.user.contact}
        onChange={(e) =>
          props.setUser(
            produce(props.user, (draft) => {
              draft.contact = e.target.value;
            })
          )
        }
      />
    );
  };

  const contactMethodField = () => {
    var propertyName = pn<User>("contactMethod");
    var property = properties.find((x) => x.propertyName === propertyName);

    return props.crudMode === "view" ? (
      <DataDisplay label={property?.displayName}>{props.user.contactMethod}</DataDisplay>
    ) : (
      <Input
        modelProperty={property}
        errors={props.validationErrors[propertyName]}
        value={props.user.contactMethod}
        onChange={(e) =>
          props.setUser(
            produce(props.user, (draft) => {
              draft.contactMethod = e.target.value;
            })
          )
        }
      />
    );
  };

  return (
    <Card transparentHeader={true} header={
            <Stack direction="row" justifyContent="space-between" alignItems="center">
              <Stack direction="row" justifyContent="space-between" alignItems="center">
                <PhoneAndroidOutlinedIcon></PhoneAndroidOutlinedIcon>
                <Typography variant="inherit" paddingLeft={"5px"}>Texting</Typography>
              </Stack>
            </Stack>
    } fullHeight>

      <Grid ref={breakpointsRef} container spacing="sm">
        {props.selectedRole?.canConfigureTexting && (
          <Grid item xs={smallFieldBreakpoints}>
            {canConfigureAndUseTextingField()}
          </Grid>
        )}

        {(!props.selectedRole?.canConfigureTexting ||
          (props.selectedRole?.canConfigureTexting && props.user.canConfigureAndUseTexting)) && (
            <>
              <Grid item xs={smallFieldBreakpoints}>
                {contactField()}
              </Grid>

              <Grid item xs={smallFieldBreakpoints}>
                {contactMethodField()}
              </Grid>
            </>
          )}
      </Grid>
    </Card>
  );
};
